export default {
	home: 'Home',
	about: 'About Us',
	services: 'Our Services',
	contact: 'Contact Us',
	shipping: 'Transport Services',
	refrigerated: 'Temperature-Controlled Cargo',
	operable: 'Cargo We Handle',
	consultation: 'Product Compliance Consultation',
	business: 'Business Cooperation',
	recruitment: 'Careers',
	switchLanguage: '切换语言',
	language: '中文',
	english: 'English',
	contactUs: 'Contact Us',
	homeTitle: "Chemfast International Transportation", // 泛思特国际运输
	homeSubtitle: "Professional · Reliable · Efficient", // 专业 安全 高效
	header: {
		findLocation: 'Find A Location',
		getSolution: 'Get Solution'
	},
	homeFst: {
		bannerTitle: 'Professional Logistics Solutions',
		bannerDesc: 'Providing efficient, secure, and reliable global transport services',
		services: {
			title: 'Specialized Transport Solutions',
			tag: 'Services',
			list: [{
					title: 'Cold Chain Transport',
					desc: 'End-to-end cold chain solutions with precision temperature control across all ranges, ensuring consistent quality from origin to destination.',
					features: ['Full Temperature Range Coverage', 'Real-Time Temperature Monitoring', 'Pharmaceutical-Grade Cold Chain Packaging', '24/7 intelligent alerts with immediate response to any temperature deviation']
				},
				{
					title: 'Dangerous Goods (DG) Transport',
					desc: 'Internationally certified DG specialists delivering safe, compliant transport solutions for all hazardous goods categories.',
					features: ['Internationally Certified', 'Dedicated DG Handling Team', 'Fully Compliant Transport Solutions', 'Emergency Response System']
				},
				{
					title: 'Pharma & Chemical Transport',
					desc: 'GMP-compliant transport services designed to meet the exacting requirements of pharmaceutical and chemical shipments.',
					features: ['GMP-Compliant Transport Environment', 'Advanced Temperature Control Systems', 'Full Shipment Visibility', 'Quality & Compliance Assurance']
				},
				{
					title: 'Lithium Battery & Electronics Transport',
					desc: 'Expert transport of lithium batteries and battery-powered devices, fully compliant with international shipping regulations.',
					features: ['International-Standard Lithium Battery Packaging', 'Professional Segregation Measures', 'IATA / IMDG Compliant', 'Certified Safe Transport']
				},
				{
					title: 'Heavy & Out-of-Gauge Cargo Transport',
					desc: 'Specialized solutions for heavy machinery and out-of-gauge shipments — efficient, safe, and tailored to global transport of industrial equipment and oversized freight.',
					features: ['Custom Loading & Unloading Plans', 'Precision Route Planning', 'Specialized Transport Equipment', 'Global Door-to-Door Service']
				},
				{
					title: 'Efficient & Customized Services',
					desc: 'Flexible, tailored freight solutions built around your needs.',
					features: ['Customized Transport Solutions', 'End-to-End Tracking & Security']
				}
			]
		},
		stats: {
			years: 'Partner Airlines',
			airlines: 'Team Members',
			routes: 'Own Warehouses',
			customers: 'Clients Served',
		},
		partners: {
			title: 'Our Partners',
			subtitle: 'Partnering with world-renowned airlines and shipping companies to deliver premium logistics services',
			airlineTitle: 'Airline Partners',
			shippingTitle: 'Shipping Partners',
		},
		news: {
			title: 'Latest News',
			subtitle: 'Stay updated with FST latest news and industry insights',
			readMore: 'Read More',
			items: [
				{
					date: '2026-05-20',
					title: 'FST Achieved CEIV Pharma Certification',
					summary: 'FST International Freight has officially obtained IATA CEIV Pharma certification, marking the highest international standard in pharmaceutical cold chain logistics.',
				},
				{
					date: '2026-04-15',
					title: 'FST Chengdu Branch Officially Opened',
					summary: 'With the growing demand for aviation logistics in Southwest China, FST has established its Chengdu branch to further enhance the nationwide network.',
				},
				{
					date: '2026-03-08',
					title: 'FST Wins WCA Best Agent Award',
					summary: 'At the 2026 WCA Annual Conference, FST was honored with the Best Agent Award for outstanding service quality and customer satisfaction.',
				},
			],
		},
	},
	aboutFst: {
		companyImageCaption: "Beijing Headquarters Office",
		stats: {
			airlines: "Partner Airlines",
			clients: "Clients Served",
			employees: "Team Members",
			warehouse: "Owned Warehouses"
		},
		title: "About Chemfast",
		heroTitle: "About Chemfast",
		companyIntro: {
			title: "Company Overview",
			subtitle: "Your One-Stop International Freight Partner",
			qualifications: {
				title: "Certifications & Qualifications",
        part1: "Beijing Chemfast International Transportation Co., Ltd. is a Class-A freight forwarder licensed by China's Civil Aviation Administration and a proud member of IATA. Founded in 2005, Chemfast operates five regional offices across",
        highlight: 'Beijing, Shanghai, Guangzhou, Zhengzhou, and Chengdu',
        part2: '.'
			},
			coreBusiness: {
				title: "Core Services",
				services: [
					"Pharmaceutical Cold Chain",
					"Biopharmaceuticals",
					"General Cargo",
					"Dangerous Goods",
					"Lithium Battery Products",
					"Out-of-Gauge Cargo",
					"Door-to-Door Delivery"
				]
			},
			advantages: {
				title: "Why Choose Us",
				items: [{
						title: "Airline Network",
						content: "Direct contracts with 20+ airlines, covering major global routes."
					},
					{
						title: "Expert Team",
						content: "260+ specialists delivering seamless, full-cycle service."
					},
					{
						title: "Enterprise Clients",
						content: "Serving 12,000+ manufacturers, traders, and import/export enterprises."
					},
					{
						title: "Warehouse Facilities",
						content: "6,200 m²+ of self-operated warehouse space, including ambient, refrigerated, and frozen zones."
					}
				]
			},
			mission: {
				title: "Our Philosophy",
        prefix: 'Built on ',
        keywords1: ['integrity'],
        keywords2: ', we combine ',
        keywords: ['deep industry expertise', 'cutting-edge technology and AI-driven innovation', 'end-to-end, door-to-door'],
        middle1: ' with ',
        middle2: ' to deliver ',
        suffix: ' freight solutions across our global network.'
			}
		},
		quickServices: [
			{ icon: 'fa fa-truck', title: 'Freight Guarantee' },
			{ icon: 'fa fa-link', title: 'Full Supply Chain' }
		],
		checkItems: [
			'Timely and secure transportation services.',
			'Integrated warehousing and distribution.',
			'Customized logistics solutions for your business.'
		],

		certificates: {
			title: "Certificates & Licenses",
			subtitle: "Professional certifications backing every shipment. | Click to view full size",
			clickHint: "Click to enlarge",
			cert1: "China Air Transport Association — Membership Certificate",
			cert1Authority: "China Air Transport Association",
			cert1Validity: "Permanent",
			cert2: "ISO Quality Management System Certificate",
			cert2Authority: "CQM Certification Group",
			cert2Validity: "2024-2027",
			cert3: "WCA Dangerous Goods Specialist Membership",
			cert3Authority: "WCA World Cargo Alliance",
			cert3Validity: "2025 Annual",
			cert4: "WCA Pharma Specialist Membership",
			cert4Authority: "WCA World Cargo Alliance",
			cert4Validity: "2025 Annual",
			cert5: "Cold Storage Temperature Device Calibration Report",
			cert5Authority: "Metrology & Verification Institute",
			cert5Validity: "Periodic Verification",
			cert6: "Civil Aviation Service Certification",
			cert6Authority: "CAST (China Academy of Civil Aviation Science and Technology)",
			cert6Validity: "2024-2027",
			cert7: "IATA Dangerous Goods Transport Qualification",
			cert7Authority: "IATA (International Air Transport Association)",
			cert7Validity: "Annual Audit",
			cert8: "GSP (Good Supply Practice) Certification",
			cert8Authority: "Medical Products Administration",
			cert8Validity: "Certified Active",
		},
		memberships: {
			title: "Memberships & Certifications",
			subtitle: "Accredited by leading international organizations — your assurance of global service quality.",
			iata: "IATA (International Air Transport Association)",
			wca: "WCA World Cargo Alliance",
			wcaDangerous: "WCA Dangerous Goods Specialist Member",
			jctrans: "JCtrans International Logistics Platform",
			jctransCert: "JCtrans Certified Member"
		},
		memberLogos: {
			title: "Membership Certifications",
			subtitle: "Member units of international authoritative organizations",
			member1: "IATA (International Air Transport Association)",
			member2: "WCA (World Cargo Alliance)",
			member3: "DGM (Dangerous Goods Management)",
			member4: "CAST (China Academy of Civil Aviation Science & Technology)",
			member5: "SICIT (Shanghai Institute of Chemical Industry Testing)",
		},
		timeline: {
			title: "Our Journey",
			subtitle: "Key Milestones",
			events: [{
					year: "2025",
					content: "AI-powered operations launched, ushering in a new era of intelligent freight forwarding.",
				},
				{
					year: "2024",
					content: "Chengdu branch opened to serve customers across Southwest China.",
				},
				{
					year: "2023",
					content: "Obtained CAAC dangerous goods freight forwarding certification.",
				},
				{
					year: "2022",
					content: "Zhengzhou branch launched, cementing our presence in China's central logistics hub.",
				},
				{
					year: "2020",
					content: "Successfully managed critical pharmaceutical cold chain shipments during the COVID-19 pandemic, demonstrating our commitment to social responsibility.",
				},
				{
					year: "2019",
					content: "Joined DGLN and WCA international networks, significantly strengthening our global capabilities.",
				},
				{
					year: "2018",
					content: "Guangzhou branch established, covering South China and completing our initial nationwide footprint.",
				},
				{
					year: "2016",
					content: "Shanghai branch opened, extending our reach across East China.",
				},
				{
					year: "2008",
					content: "Achieved IATA dangerous goods certification, establishing a regulated framework for DG operations.",
				},
				{
					year: "2005",
					content: "Chemfast was founded in Beijing<br/> specializing in air freight forwarding for dangerous goods.",
				}
			]
		},
		branches: {
			title: "Nationwide Presence",
			subtitle: "A transport network spanning China's major economic regions.",
			beijing: {
				city: "Beijing Headquarters",
				year: "Est.2005",
				cityWithYear: "Beijing HQ",
				desc: "Founded in 2005 and approved by both China's Ministry of Commerce and the China Air Transport Association, our Beijing headquarters is a Class-A freight forwarder specializing in chemicals, dangerous goods, pharmaceutical cold chain, lithium batteries, and premium consumer goods.",
				officeArea: "1,821 m²",
				warehouseArea: "2,935 m²"
			},
			shanghai: {
				city: "Shanghai Branch",
				year: "Est.2016",
				cityWithYear: "Shanghai Branch",
				desc: "Our Shanghai branch handles air freight, ocean freight, and inland transportation, supported by a dedicated 990 m² warehouse with multi-zone cold storage.",
				officeArea: "400㎡",
				warehouseArea: "990㎡"
			},
			guangzhou: {
				city: "Guangzhou Branch",
				year: "Est.2018",
				cityWithYear: "Guangzhou Branch",
				desc: "The Guangzhou branch specializes in international air freight, inland transport, and Greater Bay Area intermodal services, with 290 m² of office space and a 660 m² cold-storage warehouse.",
				officeArea: "290㎡",
				warehouseArea: "660㎡"
			},
			zhengzhou: {
				city: "Zhengzhou Branch",
				year: "Est.2022",
				cityWithYear: "Zhengzhou Branch",
				desc: "Established in 2022, our Zhengzhou branch covers 112 m² of office space and operates a 440 m² independent warehouse.",
				officeArea: "112㎡",
				warehouseArea: "440㎡"
			},
			chengdu: {
				city: "Chengdu Branch",
				year: "Est.2023",
				cityWithYear: "Chengdu Branch",
				desc: "Our Chengdu branch, established in 2023, operates a 1,170 m² dedicated warehouse serving Southwest China.",
				officeArea: "50㎡",
				warehouseArea: "1,170 m²"
			}
		},
		common: {
			established: "Est.",
			officeArea: "Office",
			warehouseArea: "Warehouse",
			loading: "loading"
		},
	},
	hero: {
		eyebrow: 'OUR SERVICES',
		title: 'Your Global Logistics Expert',
		subtitle: 'Chemfast International Transportation — Connecting the World, One Shipment at a Time'
	},
	NavigationServices: {
		airTag: 'AIRLINE NETWORK',
		airTitle: 'Chemfast Airline Network',
		airDescription: 'With direct contracts with 20+ airlines, Chemfast provides access to major global routes spanning Europe, the Americas, Southeast Asia, India, the Middle East, Africa, and Oceania.',
		seaTag: 'OCEAN FREIGHT',
		seaTitle: 'Chemfast Ocean Freight Network',
		seaDescription: "Partnered with the world's leading shipping lines to deliver reliable global ocean freight services.",
		wcaTitle: "WCA Member",
		wcaDescription: "Chemfast is a proud member of the WCA (World Cargo Alliance), an international network that empowers us to deliver comprehensive services worldwide. This ensures every client, no matter where they are, receives the highest-value service and optimal cargo handling."
	},
	refrigeratedGoods: {
		tag: "COLD CHAIN",
		title: "Categories of Temperature-Controlled Cargo",
		subtitle: "Precision Control · Full Visibility · Total Reliability",
		introduction: "We provide expert temperature-controlled transport for pharmaceuticals, chemicals, fresh produce, and other temperature-sensitive cargo — ensuring peak condition from pickup to delivery.",
		viewDetails: "View Details",
		tempRangeTitle: "Our Temperature Control Range",
		tempRecorder: {
			title: "Real-Time Temperature Data",
			altText: "Temperature Recorder",
			downloadBtn: "Download Full Report",
			data: [{
					label: "Current Temperature",
					value: "22.5°C",
					highlight: false
				},
				{
					label: "Average Temperature",
					value: "21.8°C",
					highlight: false
				},
				{
					label: "Max Temperature",
					value: "25.2°C",
					highlight: true
				},
				{
					label: "Min Temperature",
					value: "18.3°C",
					highlight: true
				},
				{
					label: "Temperature Fluctuation",
					value: "±1.2°C",
					highlight: false
				},
				{
					label: "Recording Duration",
					value: "36 Hours",
					highlight: false
				}
			]
		},
		features: [{
				icon: "fas fa-temperature-low",
				title: "Precision Temperature Control",
				description: "±1°C accuracy, meeting the strictest requirements for sensitive cargo.",
				color: "#4a89dc"
			},
			{
				icon: "fas fa-map-marked-alt",
				title: "Full Visibility",
				description: "GPS tracking combined with real-time temperature monitoring throughout the entire journey.",
				color: "#3bafda"
			},
			{
				icon: "fas fa-shield-alt",
				title: "Safety Assurance",
				description: "Expert team and contingency plans to safeguard every shipment.",
				color: "#37bc9b"
			},
			{
				icon: "fas fa-file-alt",
				title: "Comprehensive Reports",
				description: "Full temperature logs and analytical reports for every shipment.",
				color: "#f6bb42"
			}
		],
		tempRanges: [{
				temp: "-25°C",
				label: "Ultra-Low Freezing",
				color: "#4fc1e9"
			},
			{
				temp: "-18°C",
				label: "Standard Freezing",
				color: "#5d9cec"
			},
			{
				temp: "2-8°C",
				label: "Refrigerated",
				color: "#a0d468"
			},
			{
				temp: "15-25°C",
				label: "Ambient",
				color: "#ffce54"
			},
			{
				temp: "30°C+",
				label: "High Temperature",
				color: "#ed5565"
			}
		],
		activeControl: {
			title: "Active Temperature Control Solutions",
			subtitle: "Real-Time Monitoring · Auto-Adjustment · Data Logging",
			equipment: [{
					name: "RKN t2 Dry Ice Container",
					image: "rknT2.jpeg",
					description: "Designed for frozen transport at -18°C and below, powered by a built-in lithium battery system.",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "-25°C to +25°C"
						},
						{
							icon: "fas fa-battery-full",
							text: "72-hour battery life"
						},
						{
							icon: "fas fa-weight",
							text: "45 kg payload"
						}
					]
				},
				{
					name: "RAP e2 Plug-in Container",
					image: "RLP.jpg",
					description: "Next-generation temperature-controlled unit with remote monitoring and adjustment capability.",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "±1°C precision"
						},
						{
							icon: "fas fa-wifi",
							text: "Real-time data transmission"
						},
						{
							icon: "fas fa-ruler-combined",
							text: "1,200 × 800 × 800 mm"
						}
					]
				},
				// {
				// 	name: "海尔温控箱",
				// 	image: "Haier.jpg",
				// 	description: "冷藏恒温控制，适用于药品运输",
				// 	specs: [{
				// 			icon: "fas fa-thermometer-half",
				// 			text: "+0°C~+25°C"
				// 		},
				// 		{
				// 			icon: "fas fa-chart-line",
				// 			text: "温度曲线记录"
				// 		},
				// 		{
				// 			icon: "fas fa-bell",
				// 			text: "异常报警"
				// 		}
				// 	]
				// },
				{
					name: "SkyCell Hybrid Refrigerating Container",
					image: "混动.jpeg",
					description: "Hybrid-powered, constant-temperature control with integrated real-time temperature logging, multi-level alarms for power failure and excursions, and remote monitoring — purpose-built for high-value pharmaceutical cold chain with full traceability.",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "+0°C to +25°C constant temp"
						},
						{
							icon: "fas fa-chart-line",
							text: "Real-time logging"
						},
						{
							icon: "fas fa-bell",
							text: "Excursion & power-loss alerts"
						}
					]
				}
				,
				{
					name: "Aupaoli Temperature-Controlled Unit",
					image: "ouboli.png",
					description: "A professional active temperature-controlled solution for long-haul transport of pharmaceuticals, biologics, and other high-value, temperature-sensitive cargo.",
					specs: [{
							icon: "fas fa-thermometer-half",
							text: "+2°C to +8°C "
						},
						{
							icon: "fas fa-satellite-dish",
							text: "Remote real-time monitoring"
						},
						{
							icon: "fas fa-shield-alt",
							text: "Multi-layer safety protection"
						}
					]
				}

			]
		},
		passiveControl: {
			title: "Passive Temperature Control Solutions",
			subtitle: "Cost-Effective · Flexible · Airport-Ready",
			options: [{
					icon: "pmx.jpg",
					title: "Foam Packaging Solutions",
					description: "An economical, high-performance temperature-control packaging option.",
					color: "#8cc152",
					features: [
						"Multiple sizes available",
						"Customizable compartments",
						"Ideal for short-haul cold chain shipments",
						"Up to 72-hour thermal protection"
					]
				},
				{
					icon: "bp.jpg",
					title: "Refrigerant Combinations",
					description: "Optimal refrigerant configurations tailored to your shipment requirements.",
					color: "#3bafda",
					features: [
						"Dry ice / gel packs / ice packs",
						"Precisely calculated quantities",
						"Controllable temperature duration",
						"Eco-friendly materials"
					]
				},
				{
					icon: "dz.jpg",
					title: "Custom Packaging",
					description: "Bespoke packaging solutions for special cargo.",
					color: "#da4453",
					features: [
						"Dedicated one-on-one customization",
						"Multi-layer insulation structure",
						"Shockproof & drop-resistant"
					]
				}
			]
		}
	},
	cargoTypes: {
		title: 'Types of Cargo We Handle',
		subtitle: 'Professional handling of all cargo types, fully compliant with safety regulations.',
		general: {
			title: 'General Cargo',
			description: 'Safe and reliable solutions for standard freight.',
			commonItems: 'Biologics & materials, pharmaceutical formulations, textiles, fine chemicals, APIs, electronics, mechanical parts, food products, and more.',
			tags: [
				'Biologics & materials',
				'pharmaceutical formulations',
				'textiles',
				'fine chemicals',
				'APIs',
				'electronics',
			]
		},
		dangerous: {
			title: 'Dangerous Goods',
			description: 'Expert dangerous goods transport solutions.',
			classes: [{
					class: 'Class 1<br>Explosives',
					name: '',
					note: 'Subdivided into 1.1–1.6 based on hazard level.',
				},
				{
					class: 'Class 2<br>Gases',
					name: '',
					subclass: 'Flammable gas / Non-flammable gas / Toxic gas',
					example: 'Aerosols, lighters',
					unNumber: 'UN1950 / UN1075',
				},
				{
					class: 'Class 3<br>Flammable Liquids',
					name: '',
					subclass: '',
					example: 'Paints, alcohol, gasoline',
					unNumber: 'UN1203 / UN1170',
				},
				{
					class: 'Class 4<br>Flammable Solids, Self-Reactive & Water-Reactive Substances',
					name: '',
					subclasses: [{
							subclass: '4.1 Flammable Solids',
							name: '',
							example: 'Alcohol wipes, peptide powder',
							unNumber: 'UN1331',
						},
						{
							subclass: '4.2 Spontaneous Combustibles',
							name: '',
							example: 'Peptide powder',
							unNumber: 'UN1350',
						},
						{
							subclass: '4.3 Dangerous When Wet',
							name: '',
							example: 'Calcium hydride',
							unNumber: 'UN1404',
						},
					],
				},
				{
					class: 'Class 5<br>Oxidizers & Organic Peroxides',
					name: '',
					subclasses: [{
							subclass: '5.1 Oxidizers',
							name: '',
							example: 'Potassium nitrate, hydrogen peroxide',
							unNumber: 'UN2067 / UN1942',
						},
						{
							subclass: '5.2 Organic Peroxides',
							name: '',
							example: 'Peroxides, hardeners',
							unNumber: 'UN3105 / UN1942',
						},
					],
				},
				{
					class: 'Class 6<br>Toxic & Infectious Substances',
					name: '',
					subclasses: [{
							subclass: '6.1 Toxic Substances',
							name: '',
							example: 'Camptothecin, influenza virus strains',
							unNumber: 'UN1541',
						},
						{
							subclass: '6.2 Infectious Substances',
							name: '',
							example: 'Pathogens, viruses',
							unNumber: 'UN2811 / UN2913',
						},
					],
				},
				{
					class: 'Class 7<br>Radioactive Materials',
					name: '',
					note: 'Categorized as Category I–III based on radiation level.',
					example: 'Medical and industrial applications',
				},
				{
					class: 'Class 8<br>Corrosives',
					name: '',
					example: 'Heptafluorobutyric acid',
					unNumber: 'UN2794 / UN1830',
				},
				{
					class: 'Class 9<br>Miscellaneous Dangerous Goods & Environmentally Hazardous Substances',
					name: '',
					example: 'Motorcycles, chemical products',
					unNumber: 'UN1845 / UN3090',
				}
			],
			notes: {
				title: 'Important Handling Notes',
				items: [
					'Dangerous goods packaging (DGP) must be provided for all DG shipments.',
					'All packaging must comply with IATA Dangerous Goods Regulations (DGR).',
					{
						title: 'Incompatible DG classes must not be co-loaded.',
						items: ['3≠5.1', '4.2≠5.1', '4.3≠8']
					}
				]
			}
		},

		special: {
			title: 'Special Cargo',
			description: 'Tailored solutions for non-standard shipments.',
			items: [{
					icon: 'fas fa-temperature-low',
					name: 'Temperature-controlled goods'
				},
				{
					icon: 'fas fa-gem',
					name: 'High-value items'
				},
				{
					icon: 'fas fa-dog',
					name: 'Live animals'
				},
				{
					icon: 'fas fa-prescription-bottle-alt',
					name: 'Pharmaceuticals'
				},
				{
					icon: 'fas fa-flask',
					name: 'Laboratory specimens'
				},
				{
					icon: 'fas fa-drumstick-bite',
					name: 'Perishable foods'
				},
				{
					icon: 'fas fa-pallet',
					name: 'Oversized freight'
				},
				{
					icon: 'fa-solid fa-robot',
					name: 'Robotics'
				}
			]
		}
	},
	common: {
		example: 'e.g.',
		unNumber: 'UN No.'
	},
	operableGoods: {
		title: "Types of Cargo We Handle",
		subtitle: "Professional handling of all cargo types to meet your transport needs",
		generalCargo: {
			title: "General Cargo",
			description: "Safe and reliable transport solutions for standard freight",
			items: "Fine chemicals, APIs, biologics & materials, agrochemicals, mechanical parts, food, apparel, and more.",
			tags: ["Fine Chemicals", "APIs", "Biopharma", "Agrochemicals", "Mechanical Parts"]
		},
		dangerousGoods: {
			title: "Dangerous Goods",
			description: "Expert dangerous goods transport solutions",
			types: [{
					class: "Class 1",
					name: "Explosives",
					examples: "Gunpowder, detonators, fireworks"
				},
				{
					class: "Class 2",
					name: "Gases",
					examples: "Compressed oxygen, liquefied gas"
				},
				{
					class: "Class 3",
					name: "Flammable Liquids",
					examples: "Gasoline, alcohol, paints"
				},
				{
					class: "Class 4",
					name: "Flammable Solids",
					examples: "Sulphur, matches"
				},
				{
					class: "Class 5",
					name: "Oxidizers",
					examples: "Hydrogen peroxide, ammonium nitrate"
				},
				{
					class: "Class 6",
					name: "Toxic Substances",
					examples: "Pesticides, cyanides"
				},
				{
					class: "Class 7",
					name: "Radioactive Materials",
					examples: "Uranium, cobalt-60"
				},
				{
					class: "Class 8",
					name: "Corrosives",
					examples: "Sulfuric acid, sodium hydroxide"
				},
				{
					class: "Class 9",
					name: "Miscellaneous",
					examples: "Lithium batteries, asbestos"
				}
			]
		},
		specialGoods: {
			title: "Special Cargo",
			description: "Tailored transport solutions for special cargo",
			items: [{
					name: "Lithium Batteries",
					icon: "battery-full"
				},
				{
					name: "Vehicles",
					icon: "car"
				},
				{
					name: "Engines",
					icon: "cog"
				},
				{
					name: "Out-of-Gauge Cargo",
					icon: "box-open"
				},
				{
					name: "Oversized Cargo",
					icon: "radiation"
				}
			]
		}
	},
	recruitmentTitle: "Join Chemfast",
	recruitmentIntro: "We're looking for passionate, talented professionals to join our team. Here, you'll have the opportunity to apply your expertise in global logistics, collaborate with industry leaders, and drive innovation in freight forwarding.",
	joinUs: {
		filterTitle: 'Filter',
		department: 'Department',
		location: 'Location',
		jobType: 'Job Type',
		allDepartments: 'All Departments',
		allLocations: 'All Locations',
		allJobTypes: 'All Types',
		departments: ['Sales Department', 'Airline Operations Department', 'Customer Service Department', 'Operations Department'],
		sales: 'Sales',
		marketing: 'Marketing',
		service: 'Customer Service',
		tech: 'Airline Operations',
		operations: 'Operations',
		fullTime: 'Full-Time',
		partTime: 'Part-Time',
		internship: 'Internship',
		beijing: "Beijing",
		shanghai: "Shanghai",
		guangzhou: "Guangzhou",
		zhengzhou: "Zhengzhou",
		chengdu: "Chengdu",
		openPositions: 'Open Positions',
		positionsAvailable: 'Open Positions',
		viewDetails: 'View Details',
		noJobsFound: 'No positions matching your criteria',
		search: 'Search',
		resetFilters: 'Reset',
		departmentLabel: 'Department: ',
		locationLabel: 'Location: ',
		typeLabel: 'Job Type: ',
		howToApply: 'How to Apply',
		contactPrompt: 'If you are interested in this position, please contact us via:',
		jobs: [{
				id: 1,
				title: 'Sales / Overseas Sales',
				department: 'Sales Department',
				location: 'Beijing',
				type: 'Full-Time',
				description: "<h3>Job Description</h3><ul><li>Develop and maintain clients for domestic and international air freight export business through digital outreach, phone, and in-person visits.</li><li>Assist the team lead in handling enquiries, quotations, and solution coordination.</li><li>Manage end-to-end shipment follow-up to ensure service quality.</li></ul><h3>Requirements</h3><ul><li>Overseas Sales: Bachelor's degree or above; CET-6 or higher with working proficiency in English; strong learning agility; overseas sales experience a plus.</li><li>Sales: Associate's degree or above (accredited full-time program); B2B sales experience preferred; basic English and strong communication skills.</li></ul>"
			},
			{
				id: 2,
				title: 'Airline Booking Coordinator',
				department: 'Airline Operations Department',
				location: 'Beijing',
				type: 'Full-Time',
				description: "<h3>Job Description</h3><ul><li>Handle flight searches, system-based space bookings, and support day-to-day operational tasks.</li><li>Execute time-sensitive enquiries and communicate updates promptly per established workflows.</li><li>Proficient with airline-specific booking portals; familiar with exception-handling procedures.</li></ul><h3>Requirements</h3><ul><li>Bachelor's degree or above (Tier-1 university preferred); basic English; proactive, detail-oriented, and able to work independently with strong analytical thinking.</li></ul>"
			},
			{
				id: 3,
				title: 'Export Customer Service',
				department: 'Customer Service Department',
				location: 'Beijing',
				type: 'Full-Time',
				description: "<h3>Job Description</h3><ul><li>Process client booking requests and send cargo receipt notices; confirm pricing with sales and arrange bookings based on cargo arrival timelines.</li><li>Verify cargo arrival photos, issue packaging instructions per client requirements, and confirm completed packaging with clients.</li><li>Review invoices for each shipment upon operations completion; confirm with clients before issuing.</li><li>Document processing: air waybill confirmation, DG declarations, customs documents, packing lists, and new or replacement certificates.</li></ul><h3>Requirements</h3><ul><li>Bachelor's degree or above; logistics or international trade major preferred; proactive, detail-oriented, and able to perform under pressure.</li></ul>"
			},
			{
				id: 4,
				title: 'Declaration & Documentation',
				department: 'Operations Department',
				location: 'Beijing',
				type: 'Full-Time',
				description: "<h3>Job Description</h3><ul><li>Review handover documents and verify inner/outer packaging compliance with DGR and classification reports.</li><li>Prepare separate documentation sets for airlines and ground handling agents.</li><li>Enter classification codes and conclusions in the booking system according to workflow requirements.</li><li>Maintain accurate cargo information in CCSP per the air waybill: piece count, weight, rate, dimensions, volume, and cargo description.</li></ul><h3>Requirements</h3><ul><li>Bachelor's degree or above; logistics or international trade major preferred; proactive, conscientious, and eager to learn.</li></ul>"
			}
		],
		sendResume: 'Please send your resume to',
		benefits: 'What We Offer',
		benefitList: [
			'Competitive Compensation & Benefits',
			'Structured, Comprehensive Training',
			'Clear Career Development Pathways',
			'A Positive, Collaborative Workplace'
		],
		benefitTitles: ['Compensation & Benefits', 'Growth & Training', 'Leave & Time Off', 'Team Culture'],
		benefitsTitle: 'Employee Well-Being & Growth',
		ctaHeading: 'We Look Forward to Having You on Board',
		ctaDescription: 'If you are ready to bring your talent to the fast-paced world of freight forwarding, please send your resume to',
		typeClassMap: {
			'全职': 'job-full-time',
			'兼职': 'job-part-time',
			'实习': 'job-internship',
			'Full-Time': 'job-full-time',
			'Part-Time': 'job-part-time',
			'Internship': 'job-internship'
		}
	},
	aboutUS: {
		title: "Contact Us",
		description: "Chemfast is a world-leading logistics provider with over 20 years of international freight forwarding experience.",
		mission: "Our Mission",
		missionContent: "Deliver innovative and reliable freight solutions that create value for customers worldwide.",
		vision: "Our Vision",
		visionContent: "To be the most trusted partner in global supply chain management.",
		values: "Our Values",
		valuesList: [
			"Customer First",
			"Integrity & Transparency",
			"Innovation & Excellence",
			"Teamwork & Collaboration"
		],
		history: "Our Journey",
		historyContent: [
			"Founded in Shanghai in 2008 with just 5 employees.",
			"Expanded operations to 10 countries by 2015.",
			"Listed on the Hong Kong Stock Exchange in 2020.",
			"Now operating across 25 countries with over 2,000 employees."
		],
		team: "Our Team",
		teamContent: "We have a dedicated team of seasoned professionals with deep industry expertise and a global perspective."
	},
	contactInfo: {
		title: "Get in Touch",
		ourContact: "Contact Information",
		address: "Office Address",
		companyAddress: "E706-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing",
		viewMap: "View on Map",
		phone: "Phone",
		businessPhone: "Sales Inquiries",
		customerService: "Customer Service",
		email: "Email",
		businessEmail: "Sales Inquiries",
		customerServiceEmail: "Customer Service",
		followUs: "Follow Us",
		wechatQR: "WeChat Official Account QR Code",
		scanQR: "Scan QR code to follow us",
		onlineConsultation: "Online Consultation",
		name: "Name",
		namePlaceholder: "Enter your name",
		company: "Company",
		companyPlaceholder: "Enter your company name",
		emailPlaceholder: "Enter your email address",
		phonePlaceholder: "Enter your phone number",
		subject: "Subject",
		selectSubject: "Select a subject",
		airFreight: "Air Freight",
		seaFreight: "Ocean Freight",
		customsClearance: "Customs Clearance",
		other: "Other",
		message: "Message",
		messagePlaceholder: "Please describe your requirements in detail...",
		submitting: "Submitting...",
		submit: "Submit Inquiry",
		submitSuccess: "Thank you for your inquiry! We will get back to you shortly.",
		globalOffices: "Our Offices",
		offices: [{
				id: 1,
				city: "Beijing",
				country: "China",
				address: "E706-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing",
			},
			{
				id: 2,
				city: "Shanghai",
				country: "China",
				address: "2/F, Building 5, No.1026 Shiwan 8th Road, Pudong New Area, Shanghai",
			},
			{
				id: 3,
				city: "Guangzhou",
				country: "China",
				address: "Room 310, Block A8, Airport E-Commerce Park, No.9 Airport Boulevard, Huadong Town, Huadu District, Guangzhou",
			}, 
			{
				id: 4,
				city: "Zhengzhou",
				country: "China",
				address: "Room 807, Tower B, Shihang Zhichuang Mansion, 200m West of Yungang Road & Huaxia Avenue Intersection, Xuedian Town, Xinzheng, Zhengzhou, Henan",
			},
			{
				id: 5,
				city: "Chengdu",
				country: "China",
				address: "Room 210, Inbound Zone, Air China Cargo Station, International Freight Area, Tianfu International Airport, Jianyang, Chengdu",
			}
		],
		countries: {
			china: "China",
			singapore: "Singapore",
			japan: "Japan",
			usa: "USA"
		},
	},
	consultationSection: {
		tag: "VALUE-ADDED",
		sectionTitle: "Compliance Consulting",
		sectionDescription: "Expert global compliance consulting for your cargo shipments.",
		services: {
			dataService: {
				category: "Data Services",
				title: "Proprietary Database",
				// text: "实时更新的国际运输法规数据库，覆盖190+国家地区，每月5000+条数据更新",
				features: [
					"200,000+ chemical product classification records accumulated",
					"30,000+ HS code classification records in current year",
					"200+ new data entries added daily",
				]
			},
			certificationService: {
				category: "Certification Services",
				title: "Authoritative Classification Reports",
				// text: "与全球20+认证机构合作，提供具有法律效力的鉴定报告，24小时快速出证",
				features: [
					"Recognized transport qualifications by IATA",
					"CNAS-accredited testing & inspection",
					"Partnered with multiple accredited agencies for fast turnaround on certificates.",
				]
			},
			mobileApp: {
				category: "Mobile Service",
				title: "Self-Inspection Mini-App — JianDingBao",
				// text: "全球首款整合多式联运合规要求的专业工具，已服务于10,000+企业，助力高效、安全、合规运输。",
				features: [
					"The ultimate engine for cargo classification data.",
					"Instant lookup for cargo classifications and DG packaging requirements.",
				]
			}
		},
		partnersSectionTitle: "Accredited Partners",
		partners: [
			{
				name: "China Customs",
				alt: "China Customs"
			},
			{
				name: "DGM",
				alt: "DGM"
			},
			{
				name: "SINO",
				alt: "SINO"
			},
			{
				name: "SICIT",
				alt: "SICIT"
			},
			{
				name: "CAAC SRIC (Second Research Institute of CAAC)",
				alt: "CAAC SRIC (Second Research Institute of CAAC)"
			},
			{
				name: "STS Tianjin",
				alt: "STS Tianjin"
			}
		]
	},
	footer: {
		title: 'Fanstar',
		brandDesc: 'At Fanstar, we specialize in seamless logistics and transport solutions tailored to meet your business needs.',
		contactPrompt: "Reach out anytime — let's build something great together.",
		subscribePlaceholder: 'Email address to Subscribe',
		subscribeBtn: 'Subscribe',
		address: 'E706-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing',
		qq: 'Contact：Bella Xu',
		phone: 'MB: +86 13810228602 (WhatsApp)',
		fax: 'Wechat: xuxfei001',
		email: 'Email: xuchunfei@fst.net.cn',
		copyright: '© 2026 Fanstar International Transportation. All Rights Reserved.',
		columns: {
			quickLinks: 'Quick Links',
			contactInfo: 'Contact Info',
			followUs: 'Follow Us',
			services: 'Logistics Services'
		},
		services: {
			freight: 'Freight Forwarding',
			warehousing: 'Warehousing',
			lastMile: 'Last Mile Delivery',
			customs: 'Customs Clearance',
			supplyChain: 'Supply Chain Management'
		},
		links: {
			home: 'Home',
			about: 'About Us',
			shipping: 'Transport Services',
			refrigerated: 'Cold Chain Cargo',
			operable: 'Cargo Types',
			consultation: 'Compliance Consulting',
			business: 'Business Inquiries',
			careers: 'Careers'
		},
		social: {
			fanstar: 'Chemfast Mini Program',
			fanstarHint: 'WeChat Mini Program',
			jdb: 'JianDingBao Mini Program',
			jdbHint: 'WeChat Mini Program',
			douyin: 'TikTok / Douyin',
			xhs: 'Xiaohongshu (RED)'
		},
		beian: {
			publicSecurity: '京公网安备 11011302005688号',
			publicSecurityUrl: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005688',
			icp: '京ICP备13034572号-1',
			icpUrl: 'https://beian.miit.gov.cn/#/Integrated/index'
		}
	},
	airlines: [{
			name: 'Lufthansa Cargo',
			logo: 'LH.jpg'
		},
		{
			name: 'Cathay Pacific Cargo',
			logo: 'guotai.jpeg'
		},
		{
			name: 'Air France-KLM Cargo',
			logo: 'Air-FranceKLM.png'
		},
		{
			name: 'British Airways World Cargo',
			logo: 'british-Airways.png'
		},
		{
			name: 'Air Canada',
			logo: 'jnd.jpg'
		},
		{
			name: 'Swiss WorldCargo',
			logo: 'Swiss-Air.png'
		},
		{
			name: 'China Eastern Airlines',
			logo: 'china-eastern.png'
		},
		{
			name: 'China Southern Airlines',
			logo: 'china-southern.jpg'
		},
		{
			name: 'Air China Cargo',
			logo: 'air-china.jpg'
		},
		{
			name: 'Hainan Airlines',
			logo: 'hnhk.jpeg'
		},
		{
			name: 'Sichuan Airlines',
			logo: 'sichuan-air.png'
		},
		{
			name: 'Turkish Cargo',
			logo: 'Turkey.jpg'
		},
		{
			name: 'Polar Air Cargo',
			logo: 'Boli-USA.jpg'
		},
		{
			name: 'Etihad Cargo',
			logo: 'Etihad-Airways.jpg'
		},
		{
			name: 'Emirates SkyCargo',
			logo: 'ek.jpg'
		},
		{
			name: 'Korean Air Cargo',
			logo: 'South-Korea.jpg'
		},
		{
			name: 'American Airlines Cargo',
			logo: 'usa.png'
		},
		{
			name: 'Singapore Airlines Cargo',
			logo: 'Singapore.jpg'
		},
		{
			name: 'LOT Polish Airlines',
			logo: 'Poland.jpg'
		},
		{
			name: 'Qatar Airways Cargo',
			logo: 'qatar.jpg'
		},
		{
			name: 'United Cargo',
			logo: 'united.png'
		},
		{
			name: 'Aeroflot',
			logo: 'Russia.jpg'
		},
		{
			name: 'Thai Airways Cargo',
			logo: 'thai.jpg'
		},
		{
			name: 'Myanmar Airways International',
			logo: 'miandian.jpg'
		},
		{
			name: 'And More',
			logo: 'gd.jpg'
		}
	],
	shippingLines: [{
			name: 'Maersk',
			code: 'MSK',
			logo: 'maersk.png'
		},
		{
			name: 'COSCO Shipping',
			code: 'COSCO',
			logo: 'cosco.png'
		},
		{
			name: 'CMA CGM',
			code: 'CMA',
			logo: 'cmacgm.png'
		},
		{
			name: 'Ocean Network Express (ONE)',
			code: 'ONE',
			logo: 'one.jpg'
		},
		{
			name: 'Yang Ming',
			code: 'YML',
			logo: 'yml.png'
		},
		{
			name: 'MSC',
			code: 'MSC',
			logo: 'msc.png'
		},
		{
			name: 'Evergreen Line',
			code: 'EMC',
			logo: 'evergreen.png'
		},
		{
			name: 'Wan Hai Lines',
			code: 'WHL',
			logo: 'wanhai.png'
		},
		{
			name: 'OOCL',
			code: 'OOCL',
			logo: 'oocl.jpg'
		},
		{
			name: 'And More',
			logo: 'gd.jpg'
		}
	],

	map: {
		title: "Beijing Chemfast International Transportation Co., Ltd.",
		googleMap: "View on Google Maps",
		baiduMap: "View on AutoNavi Map",
		companyLocation: "Our Location",
	},

	homeHero: {
		slides: [
			{
				alt: 'Air Freight',
				badge: 'Logistics & Transport',
				headline: 'Global Air Freight<br/>Specialist',
				desc: 'Access to 260+ airlines, delivering efficient and secure air logistics solutions.',
				cta: 'Our Services'
			},
			{
				alt: 'Dangerous Goods Transport',
				badge: 'DG Specialist',
				headline: 'Dangerous Goods<br/>Safe & Compliant',
				desc: 'With 20 years of DG experience, our expert team provides full-chain management across all 9 hazard classes.',
				cta: 'Get a Quote'
			},
			{
				alt: 'Cold Chain Transport',
				badge: 'Cold Chain',
				headline: 'Pharma & Chemical<br/>Cold Chain Expert',
				desc: 'Professional cold chain equipment and technical team with real-time temperature monitoring for pharmaceutical and chemical shipments.',
				cta: 'Learn More'
			}
		],
		mapHint: 'Click city markers for details',
		branches: {
			beijing: { contact: 'Bella Xu', phone: '+86 13810228602', address: 'E706-E712, 7/F, Building 2, No.8 Airport North Street, Shunyi District, Beijing' },
			shanghai: { contact: 'Bella Xu', phone: '+86 13810228602', address: '2/F, Building 5, No.1026 Shiwan 8th Road, Pudong New Area, Shanghai' },
			guangzhou: { contact: 'Bella Xu', phone: '+86 13810228602', address: 'Room 310, Block A8, Airport E-Commerce Park, No.9 Airport Boulevard, Huadong Town, Huadu District, Guangzhou' },
			zhengzhou: { contact: 'Bella Xu', phone: '+86 13810228602', address: 'Room 807, Tower B, Shihang Zhichuang Mansion, 200m West of Yungang Road & Huaxia Avenue Intersection, Xuedian Town, Xinzheng, Zhengzhou, Henan' },
			chengdu: { contact: 'Bella Xu', phone: '+86 13810228602', address: 'Room 210, Inbound Zone, Air China Cargo Station, International Freight Area, Tianfu International Airport, Jianyang, Chengdu' }
		},
		provinceNames: { beijing: 'Beijing', shanghai: 'Shanghai', guangzhou: 'Guangdong', zhengzhou: 'Henan', chengdu: 'Sichuan' }
	},

	businessPage: {
		heroSubtitle: 'Whatever your transport and logistics needs, our professional team is ready to deliver tailored solutions.',
		companyAddressLabel: 'Company Address',
		phoneLabel: 'Phone',
		primaryPhone: '134 0103 8003',
		landlinePhone: '010-8048-6231',
		emailLabel: 'Email',
		contactEmail: 'liuqian@fst.net.cn',
		sendEmail: 'Send Email',
		mapUnavailable: 'Map is temporarily unavailable',
		mapReload: 'Reload',
		headquartersAddressTitle: 'Headquarters Address',
		getDirections: 'Get Directions',
		directPhoneTitle: 'Direct Line',
		landlineWithLabel: 'Landline: 010-8048-6231',
		onlineContactTitle: 'Online Contact',
		viewInGoogleMaps: 'View on Google Maps',
		viewInAmap: 'View on Amap (Gaode)',
		officesDescription: 'Covering key logistics hubs across China, delivering efficient, localized service.',
		officeTagHeadquarters: 'HQ',
		officeTagEastChina: 'East China',
		officeTagSouthChina: 'South China',
		officeTagCentralChina: 'Central China',
		officeTagSouthwestChina: 'Southwest China',
		mapErrorRateLimit: 'Daily API quota reached. Please try again tomorrow or change your API key.',
		mapErrorUnavailable: 'Map service is temporarily unavailable. Please try again later.',
		amapSearchKeyword: 'Chemfast'
	},

	servicesPage: {
		emergency: {
			title: 'Need Urgent Assistance?',
			description: 'Our expert team provides 24/7 comprehensive logistics support.'
		},
		cta: {
			title: 'Tailored Logistics Solutions',
			description: 'Build the optimal transport plan around your business needs — reduce costs and boost efficiency.'
		},
		scrollHint: {
			text: 'Scroll for next service'
		}
	},
}